<template>
  <article>
    <div v-if="hasAuth.isCouponsIssueWorkflowView">
      <div ref="header" class="search-top">
        <search-input
          :imgSrc="imgSrc"
          v-model="queryForm.keyword"
          placeholder-word="请输入客户姓名/手机号"
          class="card-check__search"
          @on-search="search">
        </search-input>
        <tab-list v-if="hasAuth.isCouponsIssueWorkflowReView"
          :tab-list="tabList"
          :status.sync="queryForm.is_reviewed"
          @tab-change="search"
          class="card-check__tab">
        </tab-list>
      </div>
      <!-- height要算准确 -->
      <scroller
        lock-x scrollbar-y
        use-pullup
        ref='myScroller'
        @on-pullup-loading="loadMore"
        :pullup-config="pullConfig"
        :height="scrollerHeight">
        <div class="card-check__group mt-20">
          <group v-for="(item,index) in dataList" :key="index" >
            <cell class="cou-cell" @click.native="handleDetail(item.id)">
              <p slot="after-title"><span class="cou-label">客户信息&nbsp;&nbsp;</span>{{{name: (item.customer || {}).display_name, phone: (item.customer || {}).mobile_number} | isCustomer}}</p>
              <p slot="after-title"><span class="cou-label">车辆信息&nbsp;&nbsp;</span>{{item.plate_number}}<template v-if="item.plate_number && item.vin">&nbsp;|&nbsp;</template>{{item.vin}}</p>
              <p slot="after-title"><span class="cou-label">发放卡券&nbsp;&nbsp;</span>
                <template v-if="couponsSendRequestTransactionType(item.transaction_type)">
                  【{{couponsSendRequestTransactionType(item.transaction_type)}}】
                </template>
                {{item.process_card}}
              </p>
              <p slot="after-title"><span class="cou-label">发放信息&nbsp;&nbsp;</span>{{item.submitter}} {{item.submit_time}}</p>
              <p slot="value">
                <em :class="`card-check__icon card-check__icon-${checkStatus[item.status].key}`">{{checkStatus[item.status].value}}</em>
              </p>
            </cell>
          </group>
          <p class="tip-text1">共{{totalNum}}条记录</p>
        </div>
      </scroller>
      <confirm
        title="驳回备注"
        cancelText="取消"
        confirmText="确定"
        v-model="showRejectConfirm"
        @on-confirm="handleConfirm('reject')">
        <group class="reject-text">
          <x-textarea
            :rows="3"
            :max="40"
            v-model="rejectText"
            placeholder="请填写驳回原因（非必填项）"
            :show-counter="true"
          ></x-textarea>
        </group>
      </confirm>
      <confirm
        title="提示"
        cancelText="取消"
        confirmText="确定"
        v-model="showPassConfirm"
        @on-confirm="handleConfirm('approve')">
        <div class="confirm-content">确认审核无误通过吗？</div>
      </confirm>
      <toast v-model="showSuccessToast" :time="2000">{{ toastText }}</toast>
      <x-alert v-model="showAlert" button-text="确定" title="驳回备注">
        <p v-if="rejectNote" class="alert-text">{{ rejectNote }}</p>
        <p v-else class="alert-text alert-text--default">当前无备注</p>
      </x-alert>
    </div>
    <article v-else ref="header" class="coupons-empty">
      暂无查看权限
    </article>
  </article>
</template>
<script>
import {
  Scroller,
  Cell,
  Group,
  Confirm,
  XTextarea,
  Toast,
  XAlert
} from '@lx-frontend/cvux'
import SearchInput from '../components/SearchInput'
import TabList from '../components/TabList'

export default {
  components: {
    SearchInput,
    TabList,
    Scroller,
    Cell,
    Group,
    Confirm,
    XTextarea,
    Toast,
    XAlert
  },
  data() {
    return {
      imgSrc: require('@/stylesheets/images/icon-search-input.png'),
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      tabList: [
        { key: 0, name: '待我审核' },
        { key: 1, name: '全部审核单' }
      ],
      totalNum: 0,
      totalPage: 0,
      queryForm: {
        is_reviewed: 0,
        count: 10,
        page: 1,
        keyword: ''
      },
      dataList: [],
      scrollerHeight: '',
      showRejectConfirm: false,
      rejectText: '',
      showPassConfirm: false,
      auditItem: 0,
      showSuccessToast: false,
      toastText: '',
      showAlert: false,
      rejectNote: '',
      url: {
        0: 'myPendingreviewList',
        1: 'reviewList'
      },
      hasAuth: {
        isCouponsIssueWorkflowView: false, // 查看
        isCouponsIssueWorkflowReView: false // 审核
      },
      checkStatus: {
        2: {
          key: 'underway',
          value: '审核中'
        },
        3: {
          key: 'pass',
          value: '已通过'
        },
        4: {
          key: 'reject',
          value: '已驳回'
        },
        5: {
          key: 'closed',
          value: '已关闭'
        }
      }
    }
  },
  filters: {
    isCustomer({ name, phone }) {
      return `${name} ${phone}`
    }
  },
  mounted() {
    this.$store.state.promiseAuth.then(auth => {
      this.hasAuth = {
        isCouponsIssueWorkflowView: auth.authList.includes('coupons.issue_workflow.view'),
        isCouponsIssueWorkflowReView: auth.authList.includes('coupons.issue_workflow.review')
      }
      if (this.hasAuth.isCouponsIssueWorkflowView) {
        this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
        if (!this.hasAuth.isCouponsIssueWorkflowReView) {
          // 没有审核权限不展示tab（默认查全部审核单）
          this.tabList = []
          this.queryForm.is_reviewed = 1
        }
        this.getData()
      }
    })
  },
  methods: {
    search() {
      this.queryForm.page = 1
      this.totalNum = 0
      this.totalPage = 0
      this.getData()
    },
    getData() {
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.cardCheck[this.url[this.queryForm.is_reviewed]](this.queryForm).then(res => {
        if (res.code === 0) {
          let data = res.data
          let count = this.queryForm.count
          this.dataList = data.send_requests.map(item => {
            return ({
              ...item,
              process_card: [
                item.coupon_count ? `优惠券*${item.coupon_count}` : '',
                item.gift_card_count ? `礼品卡*${item.gift_card_count}` : '',
                item.coupon_package_count ? `券包*${item.coupon_package_count}` : ''
              ].filter(item => item !== '').join('、')
            })
          })
          this.totalNum = data.total_size
          this.totalPage = parseInt((this.totalNum + count - 1) / count)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        ++this.queryForm.page
        this.$rest.cardCheck[this.url[this.queryForm.is_reviewed]](this.queryForm).then(res => {
          if (res.code === 0) {
            let data = res.data
            let count = this.queryForm.count
            this.totalNum = data.total_size
            this.totalPage = parseInt((this.totalNum + count - 1) / count)
            this.dataList.push(...data.send_requests.map(item => {
              return ({
                ...item,
                process_card: [
                  item.coupon_count ? `优惠券*${item.coupon_count}` : '',
                  item.gift_card_count ? `礼品卡*${item.gift_card_count}` : '',
                  item.coupon_package_count ? `券包*${item.coupon_package_count}` : ''
                ].filter(item => item !== '').join('、')
              })
            }))
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    },
    couponsSendRequestTransactionType(status) {
      const state = {
        1: '赠送',
        2: '购买'
      }
      return state[status] || ''
    },
    // 审核详情
    handleDetail(id) {
      this.$router.push({ path: '/cardCheck/detail', query: { id } })
    },
    // 审核
    onCheck(action, id) {
      this.auditItem = id
      if (action === 'approve') {
        this.showPassConfirm = true
      } else {
        this.rejectText = ''
        this.showRejectConfirm = true
      }
    },
    handleConfirm(action) {
      const params = action === 'approve' ? {
        id: this.auditItem
      } : {
        id: this.auditItem,
        reject_note: this.rejectText
      }
      this.$rest.coupon.check(params, `${action}_coupon_send/${this.auditItem}`).then(res => {
        if (res.code === 0) {
          this.toastText = action === 'approve' ? '审核通过' : '已驳回'
          this.showSuccessToast = true
          this.getData()
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/coupon/record";
@bgColor: #3975C6;
/deep/ .cou-label {
  color: #80838E;
}
.search-top {
  margin: -2/@w2 auto 30/@w2;
}
/deep/ input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

/deep/ .card-check {
  &__search {
    background: @bgColor;
    border-radius: 0;
    &.search_input {
      .weui_cell {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 35px;
      }
    }
  }
  &__tab {
    background: @bgColor;
    height: auto;
    .tab-service-detail {
      background: @bgColor;
      border: 0;
      li {
        a {
          color: #fff;
          font-weight: 400;
        }
        &.on a {
          color: #fff;
          font-weight: bold;
          &::before{
            background: #fff;
          }
        }
      }
    }
  }
  &__group {
    padding: 0 30/@w2 30/@w2;
    .vux-no-group-title {
      border-radius: 16/@w2;
      font-size: 28/@w2;
    }
  }
  &__icon {
    position: absolute;
    right: 0;
    top: 0;
    width: 104/@w2;
    height: 40/@w2;
    line-height: 40/@w2;
    font-weight: 400;
    font-size: 24/@w2;
    text-align: center;
    background: #DAEBFF;
    border-radius: 0 16/@w2;
    color: #3975C6;
    &-reject {
      color: #F33334;
      background: #FFE3E3;
    }
    &-pass {
      color: #08AD73;
      background: #CEF1E4;
    }
    &-closed {
      color: #999;
      background: #99999924;
    }
  }
}
.coupons-empty {
  line-height: 50/@w2;
  padding: 80/@w2;
  color: #989EA9;
  text-align: center;
}

.btn-show-remark {
  border: 1px solid #fb3f3f;
  color: #fb3f3f;
  padding: 0 7/@w;
  height: 26/@w;
  line-height: 26/@w;
  display: inline-block;
}

.reject-text {
  border-left: 1px solid #d9d9d9;
  border-right: 1px solid #d9d9d9;
}

.confirm-content {
  margin-top: 20px;
  text-align: center;
}

.alert-text {
  margin-top: 20px;
  &--default {
    color: #999999;
  }
}

.last-info {
  display: flex;
    &__label {
      flex-basis: 160/@w2;
      flex-shrink: 0;
      line-height: 1.6;
    }
  .info-reason {
    &__text {
      line-height: 1.6;
      white-space: pre-wrap;
      word-break: break-all;
    }
    &__img-wrap {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    &__img {
      width: 120/@w2;
      height: 120/@w2;
      border-radius: 4/@w2;
      margin-right: 4/@w2;
    }
  }
}
</style>
